import $ from 'jquery';

const queuedRequests = [];
let updateInProgress = false;

export function enqueueUpdate({ url, data }) {
  queuedRequests.push({ url, data });

  if (!updateInProgress) {
    updateInProgress = true;
    updateReport();
  }
}

function updateReport() {
  const { url, data } = queuedRequests.shift();

  $.ajax({
    type: 'PUT',
    url,
    data,
    complete: () => {
      if (queuedRequests.length > 0) {
        updateReport();
      } else {
        updateInProgress = false;
      }
    },
  });
}
